import ContainerPainel from 'components/container_painel';
import React, { useEffect } from 'react';
import { useAuth } from 'contexts/auth/auth_context';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import PacoteMunicipalManager from './municipalManager';
import { Box, Divider, Typography } from '@mui/material';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import PacoteStateManager from './stateManager';

const PacoteFormularios: React.FC = () => {
  const { user } = useAuth();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !hasPermission(ModuleEnum.FORMS, PermissionType.LIST)) {
      alert('Você não tem permissão para acessar esta página.');
      navigate(ROUTES.HOME);
    }
  }, [hasPermission, navigate, user]);

  const temPermissao = user?.permission?.name && Object.values(UserPermissionEnum).includes(user.permission.name as UserPermissionEnum);
  const isStateManager = user?.permission?.name === UserPermissionEnum.STATE_MANAGER || user?.permission?.name === UserPermissionEnum.ADMIN;

  return (
    <ContainerPainel pagina="Gerenciar Formulários" showBackButton={true}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        maxWidth={'1400px'}
        mx='auto'
        px={6}
        pt={2}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '22px',
            lineHeight: '160%',
            letterSpacing: '0.15px',
          }}
        >
          Gerenciar Formulários
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '150%',
            letterSpacing: '0.15px',
          }}
        >
          Para enviar o pacote de formulários ao Gerente Estadual, certifique-se de que todos os formulários estejam com o status Cadastrado.
        </Typography>

        <Divider sx={{ my: 2 }} />
      </Box>

      <Box display="flex" flexDirection="column" gap={2} alignItems="center" width="100%">
        {temPermissao && <PacoteMunicipalManager user={user} />}
        {isStateManager && <PacoteStateManager user={user} />}
      </Box>
    </ContainerPainel>
  );
};

export default PacoteFormularios;
